/* People's Peps: Insights page behaviour.
   Customizer-safe by construction:
     - one re-entry guard, so a second copy of this file is a no-op;
     - every handler is delegated on document, so it survives the theme
       editor replacing a section's innerHTML;
     - per-section state is re-hydrated on shopify:section:load, scoped to
       e.target, and torn down on shopify:section:unload.
   Nothing here reads document.currentScript: it is null after a re-render. */
(function () {
  if (window.__ppInsWired) return;
  window.__ppInsWired = true;

  var reduced = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* ---- carousel: dots reflect and drive the scroll position ---------- */
  function pages(track) {
    var card = track.querySelector('.pp-inscar__card');
    if (!card) return { per: 1, count: 1, step: 1 };
    var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    var step = card.offsetWidth + gap;
    var per = Math.max(1, Math.round(track.clientWidth / step));
    var total = track.children.length;
    return { per: per, count: Math.max(1, Math.ceil(total / per)), step: step * per };
  }

  function buildDots(root) {
    var track = root.querySelector('[data-pp-ins-track]');
    var wrap = root.querySelector('[data-pp-ins-dots]');
    if (!track || !wrap) return;
    var p = pages(track);
    if (wrap.childElementCount !== p.count) {
      wrap.textContent = '';
      for (var i = 0; i < p.count; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pp-inscar__dot';
        b.setAttribute('data-pp-ins-dot', String(i));
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        wrap.appendChild(b);
      }
    }
    syncDots(root);
  }

  function syncDots(root) {
    var track = root.querySelector('[data-pp-ins-track]');
    var wrap = root.querySelector('[data-pp-ins-dots]');
    if (!track || !wrap) return;
    var p = pages(track);
    var i = p.step ? Math.round(track.scrollLeft / p.step) : 0;
    var dots = wrap.querySelectorAll('[data-pp-ins-dot]');
    for (var n = 0; n < dots.length; n++) {
      dots[n].setAttribute('aria-current', n === i ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest ? e.target.closest('[data-pp-ins-dot]') : null;
    if (!dot) return;
    var root = dot.closest('[data-pp-ins-carousel]');
    var track = root && root.querySelector('[data-pp-ins-track]');
    if (!track) return;
    var p = pages(track);
    track.scrollTo({ left: p.step * parseInt(dot.getAttribute('data-pp-ins-dot'), 10),
                     behavior: reduced() ? 'auto' : 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute && t.hasAttribute('data-pp-ins-track')) {
      var root = t.closest('[data-pp-ins-carousel]');
      if (root) syncDots(root);
    }
  }, true);

  /* ---- FAQ: one answer open at a time, per section ------------------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.classList.contains('pp-insfaq__item') || !d.open) return;
    var root = d.closest('[data-pp-ins-faq]');
    if (!root || root.getAttribute('data-single') !== 'true') return;
    root.querySelectorAll('details.pp-insfaq__item[open]').forEach(function (o) {
      if (o !== d) o.open = false;
    });
  }, true);

  /* ---- card grid: reveal the rest -------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-pp-ins-more]') : null;
    if (!b) return;
    var root = b.closest('[data-pp-ins-cards]');
    if (!root) return;
    root.querySelectorAll('[data-pp-ins-hidden]').forEach(function (el) {
      el.removeAttribute('hidden');
      el.removeAttribute('data-pp-ins-hidden');
    });
    b.remove();
  });

  /* ---- init / re-hydrate -------------------------------------------- */
  function initSection(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-pp-ins-carousel]').forEach(buildDots);
    if (root.matches && root.matches('[data-pp-ins-carousel]')) buildDots(root);
  }
  function initAll() { initSection(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(initAll, 150);
  });

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-pp-ins-dots]').forEach(function (w) { w.textContent = ''; });
  });
})();
